import { useCallback, useMemo } from "react";
import type { SortingState, Updater } from "@tanstack/react-table";
import { useFilters } from "../../../../../utils/hooks/useFilters";

export const useUrlSort = (defaultSort?: SortingState) => {
    const [filters, setFilters] = useFilters();

    const sorting = useMemo(() => {
        return filters.sortBy?.length
            ? filters.sortBy
            : (defaultSort ?? []);
    }, [filters.sortBy, defaultSort]);

    const onSortingChange = useCallback((updater: Updater<SortingState>) => {
        setFilters("sortBy", updater);
    }, [setFilters]);

    return [sorting, onSortingChange] as const;
};
